import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteCourseFilterImageComponent } from './website-course-filter-image.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [WebsiteCourseFilterImageComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WebsiteCourseFilterImageComponent]
})
export class WebsiteCourseFilterImageModule { }
